export default "__VITE_ASSET__D9TnMfLH__"